(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "../../../store";
import { selectors as appSelectors } from "../../App";
import { hsCodeDetailsSelector, countryCodeSelector } from "../state/selectors";
import { fetchHsCodeDetails } from "../state/actions";
import HsCodesTree from "../../../components/HsCodesTree";
import useLanguage from "../../Translation/hooks/useLanguage";
import useQueryParams from "../../../hooks/useQueryParams";

const scrollToTop = () => {
  const targetElement = document.getElementById("se-hs-code-container"); // Scroll the target element into view

  targetElement.scrollIntoView({
    behavior: "smooth"
  });
};

const HsCodesTreeContainer = _ref => {
  var _hsCodeDetails$childr, _hsCodeDetails$childr2;

  let {
    code,
    description,
    searchCode
  } = _ref;
  const [isLoading, setIsLoading] = useState(false);
  const countryCode = useSelector(countryCodeSelector);
  const config = useSelector(appSelectors.configSelector);
  const {
    dir
  } = useLanguage();
  const isRtl = dir === "rtl";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    hsCode
  } = useParams();
  const [{
    country
  }] = useQueryParams();
  const hsCodeDetails = useSelector(state => hsCodeDetailsSelector(state, {
    hsCode: code,
    countryCode: country || countryCode
  }));
  const isCollapsable = (code === null || code === void 0 ? void 0 : code.length) < 10; // TODO: 10 shoul be env variable, it's the max length of hscode for specific country

  const onOpen = useCallback(openCode => {
    if (isCollapsable) {
      setIsLoading(true);
      dispatch(fetchHsCodeDetails({
        hsCode: code,
        countryCode: country || countryCode
      }));
    } else if ((openCode === null || openCode === void 0 ? void 0 : openCode.length) >= 10) {
      // TODO: 10 shoul be env variable, it's the max length of hscode for specific country
      scrollToTop();

      if (!openCode.includes(hsCode)) {
        const searchValue = (openCode === null || openCode === void 0 ? void 0 : openCode.length) > 9 ? openCode.substring(0, 6) : openCode;
        const pathname = location.pathname.replace(/\/search\/\d+$/, "/search/".concat(searchValue));
        navigate({
          pathname,
          search: location.search
        }, {
          state: {
            action: "REPLACE"
          }
        });
      }
    }
  }, [code, hsCode, country, countryCode, dispatch, location, navigate, isCollapsable]);
  useEffect(() => {
    if (isLoading && hsCodeDetails) {
      setIsLoading(false);
    }
  }, [hsCodeDetails, isLoading]);
  const canHasChildren = hsCodeDetails && hsCodeDetails.level <= 10; // TODO: 10 shoul be env variable, it's the max length of hscode for specific country

  return /*#__PURE__*/React.createElement(HsCodesTree, {
    isLoading: isLoading,
    collapsable: isCollapsable,
    code: code,
    searchCode: searchCode,
    description: description,
    warningMessage: canHasChildren && !((_hsCodeDetails$childr = hsCodeDetails.children) !== null && _hsCodeDetails$childr !== void 0 && _hsCodeDetails$childr.length) && "This heading does not contain any HS codes" || null,
    onOpen: onOpen,
    colors: config.colors,
    isRtl: isRtl
  }, canHasChildren && (hsCodeDetails === null || hsCodeDetails === void 0 ? void 0 : (_hsCodeDetails$childr2 = hsCodeDetails.children) === null || _hsCodeDetails$childr2 === void 0 ? void 0 : _hsCodeDetails$childr2.map(child => {
    var _child$children;

    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: child.code
    }, child.children ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HsCodesTree.Child, {
      isSubChild: true,
      isRtl: isRtl
    }, /*#__PURE__*/React.createElement(HsCodesTree, {
      title: child !== null && child !== void 0 && child.isFilled ? child.description : null,
      description: child !== null && child !== void 0 && child.isFilled ? null : child.description,
      code: child.code,
      isRtl: isRtl,
      isSubTree: child === null || child === void 0 ? void 0 : child.isFilled,
      colors: config.colors
    }, child.children && (child === null || child === void 0 ? void 0 : (_child$children = child.children) === null || _child$children === void 0 ? void 0 : _child$children.map(cChild => /*#__PURE__*/React.createElement(HsCodesTree.Child, {
      key: cChild.code,
      isRtl: isRtl
    }, /*#__PURE__*/React.createElement(HsCodesTreeContainer, {
      code: cChild.code,
      description: cChild.description,
      searchCode: searchCode
    }))))))) : /*#__PURE__*/React.createElement(HsCodesTree.Child, {
      isRtl: isRtl
    }, /*#__PURE__*/React.createElement(HsCodesTreeContainer, {
      code: child.code,
      description: child.description,
      searchCode: searchCode
    })));
  })));
};

__signature__(HsCodesTreeContainer, "useState{[isLoading, setIsLoading](false)}\nuseSelector{countryCode}\nuseSelector{config}\nuseLanguage{{ dir }}\nuseDispatch{dispatch}\nuseNavigate{navigate}\nuseLocation{location}\nuseParams{{ hsCode }}\nuseQueryParams{[{ country }]}\nuseSelector{hsCodeDetails}\nuseCallback{onOpen}\nuseEffect{}", () => [useSelector, useSelector, useLanguage, useDispatch, useNavigate, useLocation, useParams, useQueryParams, useSelector]);

HsCodesTreeContainer.propTypes = {
  code: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  searchCode: PropTypes.string
};
HsCodesTreeContainer.defaultProps = {
  searchCode: null
};

const _default = /*#__PURE__*/React.memo(HsCodesTreeContainer);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(scrollToTop, "scrollToTop", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/HsCodesTreeContainer.jsx");
  reactHotLoader.register(HsCodesTreeContainer, "HsCodesTreeContainer", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/HsCodesTreeContainer.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/HsCodesTreeContainer.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();